import { StyledCircleCheckIconWrapper } from './StyledCircleCheckIconWrapper'
import { CircleCheckIcon } from '../../../Icons/CircleCheckIcon'
import React, { useEffect, useState } from 'react'
import { t } from 'i18next'

const AccessibleCatallogsCheck = ({ accessibleCatalogs }) => {
    const [isValid, setIsValid] = useState(false)
    useEffect(() => {
        setIsValid(!!accessibleCatalogs.length)
    }, [accessibleCatalogs])

    return (
        <>
            <StyledCircleCheckIconWrapper>
                <CircleCheckIcon variant={isValid ? 'optional' : 'none'} />
            </StyledCircleCheckIconWrapper>
            <span>{t('header:articleCatalog')}</span>
        </>
    )
}

export default AccessibleCatallogsCheck